webpackJsonp([7],{

/***/ 178:
/***/ (function(module, exports) {

module.exports = {"forma-equipos":"Forma dos equipos","continuar":"Continuar","azul":"Azul","naranja":"Naranja"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.9b1c008391a6e621aef5.js